import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PoNotificationService } from '@po-ui/ng-components';
import { PoStorageService } from '@po-ui/ng-storage';
import { Observable } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { LiteralsWords } from 'src/app/i18n/literals.model';
import { LiteralsService } from 'src/app/shared/services/literals-service';
import { environment } from 'src/environments/environment';
import { IParameter } from '../interfaces/IParameter';

@Injectable({
  providedIn: 'root'
})
export class ParameterService {
  literals: LiteralsWords;
  private parameterUrl = 'api/framework/v1/systemParameters/';
  private parameterPGVUrl = 'api/pgv/checkconfigappserver/getParameter/v1/';
  isError = false;

  constructor(
    private http: HttpClient,
    private poStorageService: PoStorageService,
    private poNotificationService: PoNotificationService,
    private literalsService: LiteralsService
  ) {
    this.literals = this.literalsService.getLiteralModule();
  }

  getParameter(parameter: string): Observable<IParameter> {
    return this.http.get<IParameter>(`${environment.url}${this.parameterPGVUrl}${parameter}`)
      .pipe(
        take(1),
        catchError(e => {
          if (e.status === 404) {
            return this.getParameterFrame(parameter, 'value')
          }
          throw e;
        })
      )
  }

  getParameterFrame(parameter: string, fields = ''): Observable<IParameter> {
    const parameters = new HttpParams().append('FIELDS', fields);
    return this.http.get<IParameter>(`${environment.url}${this.parameterUrl}${parameter}`, { params: parameters })
      .pipe(
        take(1),
        catchError(e => {
          if (e.status === 403) {
            this.isError = true;
          }
          throw e;
        })
      )
  }

  async isCountryBRA(): Promise<boolean> {
    return await new Promise((resolve, reject) => {
      this.poStorageService
        .get('MV_PAISLOC')
        .then(country => {
          resolve(country === 'BRA');
        })
        .catch(err => {
          this.poNotificationService.error(`${this.literals.str0518}: ${err}`);
          reject(false);
        });
    });
  }

  async canUseProductBalance(): Promise<boolean> {
    return await new Promise((resolve, reject) => {
      this.poStorageService
        .get('MV_PGVCSLD')
        .then(result => resolve(result))
        .catch(() => {
          this.poNotificationService.error(this.literals.str0563); // Falha ao consultar parâmetro MV_PGVCSLD
          reject(false);
        });
    });
  }

  setStorageParameter(parameter: string, fnHandleParameterValue): void {
    this.getParameter(parameter)
      .pipe(take(1))
      .subscribe({
        next: response =>
          this.poStorageService.set(parameter, fnHandleParameterValue(response.value[0].parameterValue)),
        error: e => {
          if (e.status !== 403) {
            this.poNotificationService.error(`${this.literals.str0675} ${parameter}`)
          }
        }
      });

  }
}
